import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [

    {
        path: '/',
        name: 'Home',
        component: Home
    },

    //会员
    {
        path: '/member',
        name: 'Member',
        component: () => import('../views/member/Index.vue'),
    },
    //自提业务
    {
        path: '/member/selfPickUp',
        name: 'SelfPickUp',
        component: () => import('../views/member/SelfPickUp.vue'),
    },
    {
        path: '/member/selfPickUp/PICK_Benefit',
        name: "DS_Benefit",
        component: () => import('../views/member/benifitViews/PICK_Benefit.vue'),
    }, {
        path: '/member/selfPickUp/PICK_Special',
        name: 'DS_Special',
        component: () => import('../views/member/specialViews/PICK_Special.vue'),
    },



    //时鲜管理
    {
        path: '/enterprise',
        name: 'Enterprise',
        component: () => import('../views/enterprise/Index.vue'),
    },

    //直营连锁
    {
        path: '/enterprise/directStore',
        name: 'DirectStore',
        component: () => import('../views/enterprise/DirectStore.vue'),
    },
    {
        path: '/enterprise/directStore/DS_Benefit',
        name: "DS_Benefit",
        component: () => import('../views/enterprise/benifitViews/DS_Benefit.vue'),
    }, {
        path: '/enterprise/directStore/DS_Special',
        name: 'DS_Special',
        component: () => import('../views/enterprise/specialViews/DS_Special.vue'),
    },

    //加盟连锁
    {
        path: '/enterprise/franchiseStore',
        name: 'franchiseStore',
        component: () => import('../views/enterprise/FranchiseStore.vue')
    },
    {
        path: '/enterprise/franchiseStore/FS_Benefit',
        name: "FS_Benefit",
        component: () => import('../views/enterprise/benifitViews/FS_Benefit.vue'),
    }, {
        path: '/enterprise/franchiseStore/FS_Special',
        name: 'FS_Special',
        component: () => import('../views/enterprise/specialViews/FS_Special.vue'),
    },





    //窗口
    {
        path: '/enterprise/windowStore',
        name: 'WindowStore',
        component: () => import('../views/enterprise/WindowStore.vue')
    },
    {
        path: '/enterprise/windowStore/WIN_Benefit',
        name: "WIN_Benefit",
        component: () => import('../views/enterprise/benifitViews/WIN_Benefit.vue'),
    }, {
        path: '/enterprise/windowStore/WIN_Special',
        name: 'WIN_Special',
        component: () => import('../views/enterprise/specialViews/WIN_Special.vue'),
    },


    //中央厨房
    {
        path: '/enterprise/centralKitchen',
        name: 'CentralKitchen',
        component: () => import('../views/enterprise/CentralKitchen.vue')
    },
    {
        path: '/enterprise/centralKitchen/CK_Benefit',
        name: "WIN_Benefit",
        component: () => import('../views/enterprise/benifitViews/CK_Benefit.vue'),
    }, {
        path: '/enterprise/centralKitchen/CK_Special',
        name: 'CK_Special',
        component: () => import('../views/enterprise/specialViews/CK_Special.vue'),
    },



    //批发市场

    {
        path: '/market',
        name: 'Market',
        component: () => import('../views/market/Index.vue'),
    },


//商品配送商
    {
        path: '/market/goods',
        name: 'Goods',
        component: () => import('../views/market/Goods.vue')
    },
    {
        path: '/market/goods/GOODS_Benefit',
        name: "GOODS_Benefit",
        component: () => import('../views/market/benifitViews/GOODS_Benefit.vue'),
    }, {
        path: '/market/goods/GOODS_Special',
        name: 'GOODS_Special',
        component: () => import('../views/market/specialViews/GOODS_Special.vue'),
    },

    //专业配送商
    {
        path: '/market/distributor',
        name: 'Distributor',
        component: () => import('../views/market/Distributor.vue')
    },
    {
        path: '/market/distributor/DIS_Benefit',
        name: "DIS_Benefit",
        component: () => import('../views/market/benifitViews/DIS_Benefit.vue'),
    }, {
        path: '/market/distributor/DIS_Special',
        name: 'DIS_Special',
        component: () => import('../views/market/specialViews/DIS_Special.vue'),
    },



//平台
    {
        path: '/market/platform',
        name: 'platform',
        component: () => import('../views/market/Platform.vue')
    },
    {
        path: '/market/platform/PL_Benefit',
        name: "GOODS_Benefit",
        component: () => import('../views/market/benifitViews/PL_Benefit.vue'),
    }, {
        path: '/market/platform/PL_Special',
        name: 'GOODS_Special',
        component: () => import('../views/market/specialViews/PL_Special.vue'),
    },






]

const router = new VueRouter({
    mode: 'history',
    routes,
    scrollBehavior() {
        return {
            x: 0,
            y: 0
        }
    }

})

export default router
